export default __webpack_public_path__ + "static/media/florishAppPreview.5d1ff2e7.webp";